import { ExtensionDurationUnit, type ContractExtensionDto } from "../../autogen/bff-api";

export const DEFAULT_EXTENSION: ContractExtensionDto = {
  duration: 1,
  unit: ExtensionDurationUnit.Years,
  exerciseDeadlineMonths: 3,
};

export const extensionSeededWithin = (contractMonthsBefore: number | null): ContractExtensionDto =>
  contractMonthsBefore == null
    ? DEFAULT_EXTENSION
    : {
        ...DEFAULT_EXTENSION,
        exerciseDeadlineMonths: Math.max(1, Math.min(DEFAULT_EXTENSION.exerciseDeadlineMonths, contractMonthsBefore - 1)),
      };

const MAX_EXTENSION_NUMBER = 999;

export const isWholeExtensionNumber = (value: number | null | undefined): value is number =>
  value != null && Number.isInteger(value) && value >= 1 && value <= MAX_EXTENSION_NUMBER;

export const isDeadlineWithinContract = (deadline: number | null, contractMonthsBefore: number | null): boolean =>
  deadline == null || contractMonthsBefore == null || deadline < contractMonthsBefore;
